import React from 'react';
import SEO from '../components/seo';
const ShippingPolicyPage = () => {
  return (
    <>
      <SEO title="配送ポリシー" />
      <section className="shippingpolicy">
        <h2>
          <span id="">配送ポリシー</span>
        </h2>
        <h3>配送時期</h3>
        <p>ご注文後、1～3日（営業日）以内に発送します。 </p>
        <h3>配送料</h3>
        <p>【レモクロ】　432円</p>
        <p>
          ・定期購入は送料分が割引となります。
          <br />
          ・配送は基本的にクリックポストとなります。日時・時間帯指定はできませんのでご了承下さい。
          <br />
          配送可能な地域：日本国内。海外配送も対応しています。
        </p>
        <p>【TAMPACK】及びシェイカー　1000円</p>
        <p>
          ・定期購入は送料分が割引となります。
          <br />
          ・配送は基本的に佐川急便です。配達指定がある場合は備考欄にご記入下さい。
          <br />
          配送可能な地域：日本国内。海外配送も対応しています。
        </p>
        <p>【その他セレクト商品】1000円</p>
        <p>
          ・配送は基本的に佐川急便です。配達指定がある場合は備考欄にご記入下さい。
          <br />
          配送可能な地域：日本国内。一部海外配送も対応しています。
        </p>
      </section>
    </>
  );
};

export default ShippingPolicyPage;
